<template>

<div v-if='isReady' class="row">

     <div v-for='(r,i) in results' :key='r.url' class="col-12 col-sm-6 col-lg-4 mb-4">
        <div class='tool-box'>

            <a :href='"/tools/" + r.url' class="tb-img">
                <img :src=" _tools.toolImage(r,true)" class="img-fluid">

                <span v-if="r.cost && r.cost != 0" class="t-price"> {{ r.cost }} </span>
                <span v-else class="t-price"> Free </span>
            </a>

            <div class="tbox-content p-4">
                <div>
                    <h4>{{ r.title }}</h4>

                    <p>
                        {{ r.info.substring(0, 100) }}
                    </p>

                    <div v-if='r.tags' class="mb-4">
                        <span class='tag text-gradient' v-for='t in r.tags.split(",")'> #{{ t }} </span>
                    </div>
                </div>

                <div class="fav-listing">
                    <a :href='"/tools/" + r.url' class="btn btn-primary">
                        Learn More
                    </a>

                    <button @click='removeFav(r,i)' class="fav-btn" title="Remove from favorites"
                         data-toggle="tooltip" data-placement="top"> 
                        <span class="icon icon-bin red"></span>
                    </button>
                </div>

            </div>
        </div>
    </div>

    <div class='col-12' v-if='total > results.length'>
        <button @click='getData()' class='btn btn-primary'>Load More ( {{ results.length }} / {{ total }} )</button>
    </div>

    <div class='col-12' v-if='isReady && !results.length'>
        <div class='alert alert-info'>
            You dont have any tools added to favourites.
        </div>
    </div>
</div>
 
</template>

<script>
    export default {
        mounted() {
            this.getData();
        },

        created() {
        },

        data() {
            var me = this;

            return {

                total   : 0,
                perPage : 12,
                page    : 1,
                isReady : false,
                results  : []
            
            }
        },

        methods : {

            getData() { 

                var me = this,
                    data = { skip : this.results.length };

                //First pull, get count
                if( !this.isReady ) {
                    data.init = 1;
                }

                me.ajax.call('usr:gfv', data, (r) => {
                    if( r.status == 'success' ) {

                        if( data.init ) {
                            me.total = r.data.total;
                        }

                        me.results = me.results.concat(r.data.results);
                        me.isReady = true;
                        
                    }
                })

            },

            removeFav( n, i ) {
                var me = this;

                me.ajax.call('usr:rmf', { t : n.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        me.results.splice(i,1);
                        $.notify("Tool removed from favourites","success");
                    }

                })
            },

            changePage( p ) {
                this.page = p;

                this.getData();

            }

        }

    }
</script>
